import React from 'react';
import style from './DownloadButton.module.css';
import DownloadSvg from "../../assets/svg/DownloadSvg";

function DownloadButton({children, ...props}) {
    return (
        <button className={style.main} {...props}>
            <div className={style.icon}>
                <DownloadSvg height='13' color='white' />
            </div>

            <div>
                {children}
            </div>
        </button>
    );
}

export default DownloadButton;